const assignmentTypes = {
  TEACHER: 'TEACHER_ASSIGNMENT',
  ALEF: 'ALEF_ASSIGNMENT',
};

export default assignmentTypes;
